<template>
  <div class="curve-item" @click="click" :class="active?'active':''">
    <img :src="curveItem.heatingPhoto" class="image"/>
    <div class="absolute flex flex-col items-center  top-0 bottom-0 left-0 right-0" >
      <div class="curve-name">{{ curveItem.modeName }}</div>
      <img
          :src="curveItem.isFavorite ?require('@/assets/icons/consumer/ic_favorite_curve_liked.svg'): require('@/assets/icons/consumer/ic_favorite_curve.svg')"
          class="favorite-icon" @click.stop="onFavoriteCurveClick"/>
      <div class="favorite-num">{{ curveItem.favoriteCount || 0 }}</div>
      <!--       :class="curveItem.isFavorite ? 'favorite-text': ''"-->
    </div>
  </div>
</template>


<script>

export default {
  name: "SystemCurveItem",
  props: {
    curveItem: {
      type: Object,
      require: true
    },
    active: {
      type: Boolean,
      require: false
    }
  },
  data() {
    return {
      prevSelectIndex: -1

    };
  },
  methods: {
    click() {
      this.$emit("click");
    },
    onFavoriteCurveClick() {
      this.$emit("onFavoriteClick");
    }
  }

};
</script>

<style scoped lang="less">
.curve-item {
  margin-right: 12px;
  border-radius: 12px;

  color: white;
  /* 可选样式 */
  flex: 0 0 auto; /* 防止子元素缩小 */
  border-radius: 12px;
  position: relative;
  width: 138px;
  height: 138px;

  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 12px;
  }

  &:last-child {
    margin-right: 16px;
  }
}

.curve-name {
  font-size: 16px;
  font-weight: 600;
  margin-top: 32px;
  line-height: 18px;
}

.favorite-icon {
  width: 24px;
  height: 24px;
  margin-top: 32px;
  font-weight: normal;
}

.favorite-num {
  font-size: 14px;
  margin-top: 6px;
  font-weight: lighter;
}

.active {
  border: 1px solid #679AFF;
}

.favorite-text {
  color: red;
}
</style>